import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { SeatDetailProps } from '../api/response';
import { formatDatePayload } from '../utils/DateHelper';

// const dummy = {
//   data: [
//     {
//       transit_id: '12XRD',
//       name: 'Phnom Penh to Siem Reap',
//       seats_layout: [
//         {
//           label: 'Van seats',
//           layout: [
//             [
//               { label: 'Driver', seat_id: 'driver', availability: '', type: 'driver' },
//               {},
//               { label: '01', seat_id: '1SE3', availability: 'availabile', type: 'twin-seat' },
//               { label: '02', seat_id: '1SE3', availability: 'availabile', type: 'twin-seat' },
//             ],
//             [null, null, null, null],
//             [
//               { label: '03', seat_id: '1SE4', availability: 'availabile', type: 'twin-seat' },
//               { label: '04', seat_id: '1SE5', availability: 'booked', type: 'twin-seat' },
//               null,
//               { label: '05', seat_id: '1SE6', availability: 'availabile', type: 'seat', watching: 2 },
//             ],
//             [
//               { label: '06', seat_id: '1SE7', availability: 'availabile', type: 'twin-seat' },
//               { label: '07', seat_id: '1SE8', availability: 'busy', type: 'twin-seat' },
//               null,
//               { label: '08', seat_id: '1SE9', availability: 'availabile', type: 'seat' },
//             ],
//             [
//               { label: '09', seat_id: '1SG1', availability: 'availabile', type: 'twin-seat' },
//               { label: '10', seat_id: '1SG2', availability: 'availabile', type: 'twin-seat' },
//               null,
//               { label: '11', seat_id: '1SG3', availability: 'availabile', type: 'seat' },
//             ],
//             [
//               { label: '12', seat_id: '1SG4', availability: 'availabile', type: 'back-seat' },
//               { label: '13', seat_id: '1SG5', availability: 'availabile', type: 'back-seat' },
//               { label: '14', seat_id: '1SG6', availability: 'availabile', type: 'back-seat' },
//               { label: '15', seat_id: '1SG7', availability: 'availabile', type: 'back-seat' },
//             ],
//           ],
//         },
//       ],
//     },
//   ],
// };

// const realDummy = {
//   name: 'main deck',
//   layout: [
//     [
//       {
//         id: 1,
//         label: 'driver',
//         type: 'driver',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 1,
//         y: 1,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//       null,
//       {
//         id: 2,
//         label: 'A01',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 3,
//         y: 1,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//       {
//         id: 3,
//         label: 'A02',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 4,
//         y: 1,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//     ],
//     [
//       {
//         id: 4,
//         label: 'A03',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 1,
//         y: 2,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//       {
//         id: 5,
//         label: 'A04',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 2,
//         y: 2,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//       null,
//       null,
//     ],
//     [
//       {
//         id: 6,
//         label: 'A05',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 1,
//         y: 3,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'booked',
//       },
//       {
//         id: 7,
//         label: 'A06',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 2,
//         y: 3,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'booked',
//       },
//       null,
//       {
//         id: 8,
//         label: 'A07',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 4,
//         y: 3,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//     ],
//     [
//       {
//         id: 9,
//         label: 'A08',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 1,
//         y: 4,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//       {
//         id: 10,
//         label: 'A09',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 2,
//         y: 4,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//       null,
//       {
//         id: 11,
//         label: 'A10',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 4,
//         y: 4,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//     ],
//     [
//       {
//         id: 12,
//         label: 'A11',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 1,
//         y: 5,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//       {
//         id: 13,
//         label: 'A12',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 2,
//         y: 5,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//       {
//         id: 14,
//         label: 'A13',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 3,
//         y: 5,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//       {
//         id: 15,
//         label: 'A14',
//         type: 'passenger',
//         vehicle_layout_id: 1,
//         vehicle_deck_id: 1,
//         x: 4,
//         y: 5,
//         created_at: '2023-01-30 08:30:01',
//         updated_at: '2023-01-30 08:30:01',
//         status: 'available',
//       },
//     ],
//   ],
// };

export const useSeatDetailsQuery = ({ tripId, date }: { tripId: string; date: Date }) => {
  const axios = useAxios();

  return useQuery<AxiosResponse<AxiosResponse<SeatDetailProps>>, unknown, SeatDetailProps>(
    ['seat-details', tripId, date],
    async () =>
      axios.get(ApiRoutes.seatDetails.replace('{{trip_id}}', tripId), {
        params: { date: formatDatePayload(date) },
      }),

    {
      select: res => {
        return res.data.data;
      },
      refetchOnWindowFocus: USE_QUERY_CONSTANTS.refetchOnWindowFocus,
      retry: USE_QUERY_CONSTANTS.retry,
      enabled: false,
      cacheTime: 0,
      // enabled: false,
      onError: erro => {
        console.log(erro);
      },
    },
  );
};
export const useSeatDetailsMutation = () => {
  const axios = useAxios();

  return useMutation<AxiosResponse<AxiosResponse<SeatDetailProps>>, AxiosError, any>(
    ['seat-details'],
    ({ tripId, date }: { tripId: number | string; date: Date }) =>
      axios.get(ApiRoutes.seatDetails.replace('{{trip_id}}', `${tripId}`), {
        params: { date: formatDatePayload(date) },
      }),
    {
      retry: USE_QUERY_CONSTANTS.retry,
      // enabled: false,
      onError: erro => {
        console.log(erro);
      },
    },
  );
};
